
// import React, { useState } from "react";
// import "./Login.css";
// import { useNavigate } from "react-router-dom";
// import logo from "../Images/logo3.png";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Login = () => {
//   const [role, setRole] = useState("student");
//   const [showPassword, setShowPassword] = useState(false);

//   const [rollNo, setRollNo] = useState("");
//   const [mobileOrPassword, setMobileOrPassword] = useState("");

//   const [email, setEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [serverOtp, setServerOtp] = useState(""); 

//   const navigate = useNavigate();

//   const validateEmail = (email) =>
//     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  
//   const handleSendOtp = async () => {
//     if (!validateEmail(email)) {
//       alert("Please enter valid email");
//       return;
//     }

//     try {
//       const response = await fetch("https://api.scannscore.com/send-otp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ email })
//       });

//       const result = await response.json();

//       if (response.ok) {
//             toast.success("Login successful!");
        
//         // alert("OTP sent successfully");

//         console.log("OTP :", result.otp);

//         setServerOtp(result.otp); 
//         setOtpSent(true);
//       } else {
//         alert(result.message);
//       }

//     } catch (error) {
//       console.error(error);
//       alert("Server error");
//     }
//   };


//   const handleVerifyOtp = async () =>  {

//     if (otp === serverOtp) {
//       // alert("OTP Verified Successfully");
//       toast.success("OTP verified succesfully ")

//      const response = await axios.post(
//         "https://api.scannscore.com/teacher-login",
//         {
//           email: email,
//         }
//       );

//       const data = response.data;
//       console.log(data.user);


//       localStorage.setItem("admin", JSON.stringify(data.user));

//       toast.success("Login successful!");

  
//       setTimeout(() => {
//         navigate("/admin/dashboard");
//         window.location.reload();
//       }, 1500);

//     } else {
//       alert("Invalid OTP");
//     }
//   };


//   const handleStudentLogin = async (e) => {
//     e.preventDefault();

//     const data = {
//       roll_no: rollNo,
//       password: mobileOrPassword,
//       role
//     };

//     try {
//       const response = await fetch("https://api.scannscore.com/student-login", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify(data)
//       });

//       const result = await response.json();

//       if (response.ok) {
//         alert("Login Successful");
//         navigate("/dashboard");
//       } else {
//         alert(result.message);
//       }

//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <div className="login-page">
//       <div className="col-lg-5 login-card rounded-5">
//         <div className="px-4 py-5">

//           <img
//             src={logo}
//             alt="logo"
//             className="d-block mx-auto mb-4 bg-white w-25 rounded-circle"
//           />

//           <h2 className="login-title text-center">
//             Login to Your Account
//           </h2>

        
//           <div className="d-flex justify-content-between my-4">

//             <button
//               className={`role-btn ${role === "student" ? "active-role" : ""}`}
//               onClick={() => setRole("student")}
//             >
//               Student
//             </button>

//             <button
//               className={`role-btn ${role === "teacher" ? "active-role" : ""}`}
//               onClick={() => setRole("teacher")}
//             >
//               Teacher
//             </button>

//           </div>

        
//           {role === "student" && (
//             <form onSubmit={handleStudentLogin}>

//               <input
//                 type="text"
//                 className="login-input"
//                 placeholder="Roll No"
//                 value={rollNo}
//                 onChange={(e) => setRollNo(e.target.value)}
//                 required
//               />

//               <div style={{ position: "relative" }}>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   className="login-input"
//                   placeholder="Mobile / Password"
//                   value={mobileOrPassword}
//                   onChange={(e) => setMobileOrPassword(e.target.value)}
//                   required
//                 />

//                 <span
//                   onClick={() => setShowPassword(!showPassword)}
//                   style={{
//                     position: "absolute",
//                     right: "15px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     cursor: "pointer"
//                   }}
//                 >
//                   {showPassword ? <FaEyeSlash /> : <FaEye />}
//                 </span>
//               </div>

//               <button className="login-btn">
//                 Login
//               </button>

//             </form>
//           )}

//           {/* TEACHER LOGIN */}
//           {role === "teacher" && (

//             <div>

//               <input
//                 type="email"
//                 className="login-input"
//                 placeholder="Teacher Email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />

//               {!otpSent && (
//                 <button
//                   className="login-btn mt-3"
//                   onClick={handleSendOtp}
//                 >
//                   Send OTP
//                 </button>
//               )}

//               {otpSent && (
//                 <>
//                   <input
//                     type="text"
//                     className="login-input mt-3"
//                     placeholder="Enter OTP"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                   />

//                   <button
//                     className="login-btn mt-2"
//                     onClick={handleVerifyOtp}
//                   >
//                     Verify OTP
//                   </button>
//                 </>
//               )}
              

//             </div>

//           )}
         
       
//         </div>

//           <div className="bottom-curve rounded-bottom-5">
//           {role == 'student' ?
//          <h6
//           style={{ cursor: "pointer" }}
//            onClick={() => navigate("/forget-password")}
//           >
//              Forgot Password
//            </h6>: <h6></h6>}
//            <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/support")}>
//              Support
//            </h6>
//          </div>

//       </div>
//       <ToastContainer
//               position="top-center"
//               autoClose={2000}
//               hideProgressBar={false}
//               newestOnTop
//               closeOnClick
//               pauseOnHover
//               theme="colored"
//             />
//     </div>
//   );
// };

// export default Login;




// import React, { useState } from "react";
// import "./Login.css";
// import { useNavigate } from "react-router-dom";
// import logo from "../Images/logo3.png";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Login = () => {
//   const [role, setRole] = useState("student");
//   const [showPassword, setShowPassword] = useState(false);

//   const [rollNo, setRollNo] = useState("");
//   const [mobileOrPassword, setMobileOrPassword] = useState("");

//   const [email, setEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [serverOtp, setServerOtp] = useState(""); 

//   const navigate = useNavigate();

//   const validateEmail = (email) =>
//     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  
//   const handleSendOtp = async () => {
//     if (!validateEmail(email)) {
//       toast.error("Please enter valid email");
//       return;
//     }

//     try {
//       const response = await fetch("https://api.scannscore.com/send-otp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ email })
//       });

//       const result = await response.json();

//       if (response.ok) {
//             toast.success("  OTP send successful!");
        
//         // alert("OTP sent successfully");

//         // console.log("OTP :", result.otp);

//         setServerOtp(result.otp); 
//         setOtpSent(true);
//       } else {
//         toast.success(result.message);
//       }

//     } catch (error) {
//       console.error(error);
//       toast.error("Server error");
//     }
//   };


//   const handleVerifyOtp = async () =>  {

//     if (otp === serverOtp) {
//       // alert("OTP Verified Successfully");
//       // toast.success("OTP verified succesfully ")

//      const response = await axios.post(
//         "https://api.scannscore.com/teacher-login",
//         {
//           email: email,
//         }
//       );

//       const data = response.data;
//       console.log(data.user);


//       localStorage.setItem("admin", JSON.stringify(data.user));

//       toast.success("Login successful!");

  
//       setTimeout(() => {
//         navigate("/admin/dashboard");
//         window.location.reload();
//       }, 1500);

//     } else {
//       // alert("Invalid OTP");
//       toast.error("Invalid OTP");
//     }
//   };


//   const handleStudentLogin = async (e) => {
//     e.preventDefault();

//     const data = {
//       roll_no: rollNo,
//       password: mobileOrPassword,
//       role
//     };

//     try {
//       const response = await fetch("https://api.scannscore.com/student-login", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify(data)
//       });

//       const result = await response.json();

//       console.log(result.student);
//       if (response.status == 200) {

 
//       localStorage.setItem("student", JSON.stringify(result.student));

//         toast.success("Login Successful");
//         setTimeout(() => {
//         navigate("/student/dashboard");
//         window.location.reload();
//       }, 1500);

//         // navigate("/student/dashboard");
        
//       } else {
//         alert(result.message);
//       }

//     } catch (error) {
//       toast.error(error);
//     }
//   };

//   return (
//     <div className="login-page">
//       <div className="col-lg-5 login-card rounded-5">
//         <div className="px-4 py-5">

//           <img
//             src={logo}
//             alt="logo"
//             className="d-block mx-auto mb-4 bg-white w-25 rounded-circle"
//           />

//           <h2 className="login-title text-center">
//             Login to Your Account
//           </h2>

        
//           <div className="d-flex justify-content-between my-4">

//             <button
//               className={`role-btn ${role === "student" ? "active-role" : ""}`}
//               onClick={() => setRole("student")}
//             >
//               Student
//             </button>

//             <button
//               className={`role-btn ${role === "teacher" ? "active-role" : ""}`}
//               onClick={() => setRole("teacher")}
//             >
//               Teacher
//             </button>

//           </div>

        
//           {role === "student" && (
//             <form onSubmit={handleStudentLogin}>

//               <input
//                 type="text"
//                 className="login-input"
//                 placeholder="Roll No"
//                 value={rollNo}
//                 onChange={(e) => setRollNo(e.target.value)}
//                 required
//               />

//               <div style={{ position: "relative" }}>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   className="login-input"
//                   placeholder="Mobile / Password"
//                   value={mobileOrPassword}
//                   onChange={(e) => setMobileOrPassword(e.target.value)}
//                   required
//                 />

//                 <span
//                   onClick={() => setShowPassword(!showPassword)}
//                   style={{
//                     position: "absolute",
//                     right: "15px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     cursor: "pointer"
//                   }}
//                 >
//                   {showPassword ? <FaEyeSlash /> : <FaEye />}
//                 </span>
//               </div>

//               <button className="login-btn">
//                 Login
//               </button>

//             </form>
//           )}

      
//           {role === "teacher" && (

//             <div>

//               <input
//                 type="email"
//                 className="login-input"
//                 placeholder="Teacher Email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />

//               {!otpSent && (
//                 <button
//                   className="login-btn mt-3"
//                   onClick={handleSendOtp}
//                 >
//                   Send OTP
//                 </button>
//               )}

//               {otpSent && (
//                 <>
//                   <input
//                     type="text"
//                     className="login-input mt-3"
//                     placeholder="Enter OTP"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                   />

//                   <button
//                     className="login-btn mt-2"
//                     onClick={handleVerifyOtp}
//                   >
//                     Verify OTP
//                   </button>
//                 </>
//               )}
              

//             </div>

//           )}
         
       
//         </div>

//           <div className="bottom-curve rounded-bottom-5">
//           {role == 'student' ?
//          <h6
//           style={{ cursor: "pointer" }}
//            onClick={() => navigate("/forget-password")}
//           >
//              Forgot Password
//            </h6>: <h6></h6>}
//            <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/support")}>
//              Support
//            </h6>
//          </div>

//       </div>
//       <ToastContainer
//               position="top-center"
//               autoClose={2000}
//               hideProgressBar={false}
//               newestOnTop
//               closeOnClick
//               pauseOnHover
//               theme="colored"
//             />
//     </div>
//   );
// };

// export default Login;




import React, { useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import logo from "../Images/logo3.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const [role, setRole] = useState("student");
  const [showPassword, setShowPassword] = useState(false);

  const [rollNo, setRollNo] = useState("");
  const [mobileOrPassword, setMobileOrPassword] = useState("");

  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [serverOtp, setServerOtp] = useState("");

  const navigate = useNavigate();

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // ================= SEND OTP =================
  const handleSendOtp = async () => {
    if (!validateEmail(email)) {
      toast.error("Please enter valid email");
      return;
    }

    try {
      const response = await fetch("https://api.scannscore.com/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const result = await response.json();

      if (response.ok) {
        setServerOtp(result.otp);
        setOtpSent(true);

        toast.success("OTP sent successfully!");
      } else {
        toast.error(result.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error("Server error");
    }
  };

  // ================= VERIFY OTP (TEACHER LOGIN) =================
  const handleVerifyOtp = async () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return;
    }

    if (otp === serverOtp) {
      try {
        const response = await axios.post(
          "https://api.scannscore.com/teacher-login",
          { email }
        );

        const data = response.data;

        localStorage.setItem("admin", JSON.stringify(data.user));

        toast.success("Login successful!");

        setTimeout(() => {
          navigate("/admin/dashboard");
          window.location.reload();
        }, 1500);
      } catch (error) {
        toast.error(error?.response?.data?.message || "Server error");
      }
    } else {
      toast.error("Invalid OTP");
    }
  };

  const handleStudentLogin = async (e) => {
    e.preventDefault();

    const data = {
      roll_no: rollNo,
      password: mobileOrPassword,
      role,
    };

    try {
      const response = await fetch(
        "https://api.scannscore.com/student-login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (response.status === 200) {
        localStorage.setItem("student", JSON.stringify(result.student));

        toast.success("Login successful!");

        setTimeout(() => {
          navigate("/student/dashboard");
          window.location.reload();
        }, 1500);
      } else {
        toast.error(result.message || "Login failed");
      }
    } catch (error) {
      toast.error("Server error");
    }
  };

  return (
    <div className="login-page">
      <div className="col-lg-5 login-card rounded-5">
        <div className="px-4 py-5">
          <img
            src={logo}
            alt="logo"
            className="d-block mx-auto mb-4 bg-white w-25 rounded-circle"
          />

          <h2 className="login-title text-center">
            Login Your Account
          </h2>

  
          <div className="d-flex justify-content-between my-4">
            <button
              className={`role-btn ${
                role === "student" ? "active-role" : ""
              }`}
              onClick={() => setRole("student")}
            >
              Student
            </button>

            <button
              className={`role-btn ${
                role === "teacher" ? "active-role" : ""
              }`}
              onClick={() => setRole("teacher")}
            >
              Teacher
            </button>
          </div>

          {role === "student" && (
            <form onSubmit={handleStudentLogin}>
              <input
                type="text"
                className="login-input"
                placeholder="Enrollment No"
                value={rollNo}
                onChange={(e) => setRollNo(e.target.value)}
                required
              />

              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="login-input"
                  placeholder="Mobile / Password"
                  value={mobileOrPassword}
                  onChange={(e) =>
                    setMobileOrPassword(e.target.value)
                  }
                  required
                />

                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button className="login-btn" type="submit">
                Login
              </button>
            </form>
          )}

       
          {role === "teacher" && (
            <div>
              <input
                type="email"
                className="login-input"
                placeholder="Teacher Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              {!otpSent && (
                <button
                  className="login-btn mt-3"
                  onClick={handleSendOtp}
                >
                  Send OTP
                </button>
              )}

              {otpSent && (
                <>
                  <input
                    type="text"
                    className="login-input mt-3"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />

                  <button
                    className="login-btn mt-2"
                    onClick={handleVerifyOtp}
                  >
                    Verify OTP
                  </button>
                </>
              )}
            </div>
          )}
        </div>

   
        <div className="bottom-curve rounded-bottom-5">
          {role === "student" ? (
            <h6
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/forget-password")}
            >
              Forgot Password
            </h6>
          ) : (
            <h6></h6>
          )}

          <h6
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/support")}
          >
            Support
          </h6>
        </div>
      </div>

   
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default Login;